import { CloudUploadOutlined, LoadingOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import React, { useState } from 'react'

const UploadButton = ({ url }) => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const handleChange = (info) => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            setLoading(false);

        }
    };

    return (
        <>
            <Upload.Dragger

                name="lead_atachment"
                // listType="picture-card"
                className="lead_detail_atachment"
                showUploadList={true}
                action={url}
                //   beforeUpload={beforeUpload}
                onChange={handleChange}
            >
                <div >
                    {loading ? <LoadingOutlined style={{ fontSize: 35, color: 'var(--color-gray)' }} /> : <CloudUploadOutlined style={{ fontSize: 35, color: 'var(--color-gray)' }} />}
                    <div style={{ marginTop: 8, }} >
                        Drag and drop a file here or click
                    </div>
                </div>
            </Upload.Dragger>
        </>
    )
}

export default UploadButton